// extracted by mini-css-extract-plugin
export var buttonContainer = "_8w-1";
export var fontSizeSelect = "_8w-3";
export var formatSelect = "_8w-2";
export var formats = "_8w-4";
export var hidden = "_8w-5";
export var icon = "_8w-6";
export var select = "_8w-0";